import React from "react";
import { PropTypes } from "prop-types";
import ReferralProgramMenu from "./ReferralProgramMenu";
function ProgramMenu(_ref) {
  var menuIsOpen = _ref.menuIsOpen,
    onClick = _ref.onClick,
    program = _ref.program,
    unselected = _ref.unselected,
    preventUngroup = _ref.preventUngroup,
    onMoveToExistingReferralClick = _ref.onMoveToExistingReferralClick,
    onMoveToExistingReferralReasonsHover = _ref.onMoveToExistingReferralReasonsHover,
    moveToNewReferralDisabled = _ref.moveToNewReferralDisabled,
    onMoveToNewReferralClick = _ref.onMoveToNewReferralClick,
    setReasonMenuIsOpen = _ref.setReasonMenuIsOpen,
    onRemoveClick = _ref.onRemoveClick,
    reasonMenuIsOpen = _ref.reasonMenuIsOpen,
    moveToReferralIndex = _ref.moveToReferralIndex,
    cannotMoveReasons = _ref.cannotMoveReasons;
  return menuIsOpen && /*#__PURE__*/React.createElement(ReferralProgramMenu, {
    unselected: unselected,
    preventUngroup: preventUngroup,
    onMoveToExistingReferralClick: onMoveToExistingReferralClick,
    onMoveToExistingReferralReasonsHover: onMoveToExistingReferralReasonsHover,
    moveToNewReferralDisabled: moveToNewReferralDisabled,
    onMoveToNewReferralClick: onMoveToNewReferralClick,
    setReasonMenuIsOpen: setReasonMenuIsOpen,
    onRemoveClick: onRemoveClick,
    reasonMenuIsOpen: reasonMenuIsOpen,
    moveToReferralIndex: moveToReferralIndex,
    cannotMoveReasons: cannotMoveReasons,
    onClickThreeDotIcon: function onClickThreeDotIcon() {
      return onClick(program === null || program === void 0 ? void 0 : program.id);
    }
  });
}
ProgramMenu.propTypes = {
  menuIsOpen: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  program: PropTypes.shape({
    id: PropTypes.string.isRequired
  }).isRequired,
  unselected: PropTypes.arrayOf(PropTypes.string),
  preventUngroup: PropTypes.bool,
  onMoveToExistingReferralClick: PropTypes.func.isRequired,
  onMoveToExistingReferralReasonsHover: PropTypes.func.isRequired,
  moveToNewReferralDisabled: PropTypes.bool,
  onMoveToNewReferralClick: PropTypes.func.isRequired,
  setReasonMenuIsOpen: PropTypes.func.isRequired,
  onRemoveClick: PropTypes.func.isRequired,
  reasonMenuIsOpen: PropTypes.bool.isRequired,
  moveToReferralIndex: PropTypes.number,
  cannotMoveReasons: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string))
};
ProgramMenu.defaultProps = {
  unselected: [],
  preventUngroup: false,
  moveToNewReferralDisabled: false,
  moveToReferralIndex: null,
  cannotMoveReasons: {}
};
export default ProgramMenu;
//# sourceMappingURL=ProgramMenu.js.map